/**
 * Asynchronously loads the component for CreateSamplePage
 */

import { lazyLoad } from 'utils/loadable';

export const Login = lazyLoad(
  () => import('./index'),
  module => module.default,
);
